import * as angular from "angular";
import {ClientRegistrationResponse} from "../models/client-registration-response.model";
import {QuickbooksRegistrationStatus} from "../models/quickbooks-registration-status.model";
import {Oauth2redirectResponse} from "../models/oauth2-redirect-response.model";
import {IHttpService} from "angular";
import {ApiConfig} from "../../commons/models/api-config.model";

export class IntegrationsRequestsService {

  /* @ngInject */
  constructor(private $http: IHttpService, private apiConfig: ApiConfig) {
  }

  getClientRegistration(siteId: string, registrationId: string): Promise<ClientRegistrationResponse> {
    return new Promise((resolve, reject) => {
      this.$http<any>({
        url: `${this.apiConfig.baseUrl}/integrations/clients/${registrationId}`,
        method: 'GET',
        params: {
          siteId: siteId
        }
      }).then((response) => {
        resolve(response.data);
      }).catch((response) => {
        reject(response.data);
      });
    });
  }

  authorizeClientRegistration(siteId: string, registrationId: string, code: string, state: string): Promise<Oauth2redirectResponse> {
    return new Promise((resolve, reject) => {
      this.$http<any>({
        url: `${this.apiConfig.baseUrl}/integrations/clients/${registrationId}/authorize`,
        method: 'GET',
        params: {
          siteId: siteId,
          code: code,
          state: state
        }
      }).then((response) => {
        resolve(response.data);
      }).catch((response) => {
        reject(response.data);
      });
    });
  }

  getQuickbooksRegistrationStatus(siteId: string, registrationId: string): Promise<QuickbooksRegistrationStatus> {
    return new Promise((resolve, reject) => {
      this.$http<any>({
        url: `${this.apiConfig.baseUrl}/integrations/quickbooks/${registrationId}/status`,
        method: 'GET',
        params: {
          siteId: siteId
        }
      }).then((response) => {
        resolve(response.data);
      }).catch((response) => {
        reject(response.data);
      });
    });
  }

  registerQuickbooks(siteId: string, registrationId: string, realmId: string): Promise<QuickbooksRegistrationStatus> {
    return new Promise((resolve, reject) => {
      this.$http<any>({
        url: `${this.apiConfig.baseUrl}/integrations/quickbooks/${registrationId}/${realmId}`,
        method: 'POST',
        params: {
          siteId: siteId
        }
      }).then((response) => {
        resolve(response.data);
      }).catch((response) => {
        reject(response.data);
      });
    });
  }

  unRegisterQuickbooks(siteId: string, registrationId: string): Promise<QuickbooksRegistrationStatus> {
    return new Promise((resolve, reject) => {
      this.$http<any>({
        url: `${this.apiConfig.baseUrl}/integrations/quickbooks/${registrationId}`,
        method: 'DELETE',
        params: {
          siteId: siteId
        }
      }).then((response) => {
        resolve(response.data);
      }).catch((response) => {
        reject(response.data);
      });
    });
  }

}

angular
  .module('bringoz.admin.integrations')
  .service('integrationsRequestsService', IntegrationsRequestsService);
